/**
 * Default values for column configurations.
 *
 * @type {{searchable: boolean}}
 */
const columnDefaults = {
  sortable: true,
  searchable: true,
  filterable: false,
  width: 200,
  grow: 1,
  shrink: 1
};

/**
 * Create column configuration based on columns provided by use case and default
 * values.
 * @param columns Columns configured in the use case
 * @returns {(*|{CellType: *, searchable: boolean})[]}
 */
const mergeColumnConfigs = (columns = []) => {
  return columns.map(column => {
    return {
      ...columnDefaults,
      ...column
    };
  });
};

// eslint-disable-next-line import/prefer-default-export
export { mergeColumnConfigs };
